import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const PageRoot = lazy(() => import('@app/components/PageRoot'))
const SSOIndexPage = lazy(() => import('./SSOIndexPage'))

class SSOIndexPageWebComponent extends ReactWebComponent {
	override render() {
		return (
			<PageRoot>
				<SSOIndexPage />
			</PageRoot>
		)
	}
}

customElements.define('sso-index-page', SSOIndexPageWebComponent)
